package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.domain.model.Visit
import fyi.moko.hotpl.domain.repository.PlaceRepository
import kotlinx.coroutines.flow.Flow

/** Streams every visit across all places — feeds the app-open recall derivation. */
class ObserveAllVisitsUseCase(
    private val repository: PlaceRepository,
) {
    operator fun invoke(): Flow<List<Visit>> = repository.observeAllVisits()
}
